import React, { createContext, useState } from 'react'

export const NextButtonAvailabilityContext = createContext({
  nextButtonAvailability: false,
  setNextButtonAvailability: () => {}
})

export const NextButtonAvailabilityProvider = ({ children }) => {
  const [nextButtonAvailability, setNextButtonAvailability] = useState(false)
  const value = { nextButtonAvailability, setNextButtonAvailability }

  return (
    <NextButtonAvailabilityContext.Provider value={value}>
      {children}
    </NextButtonAvailabilityContext.Provider>
  )
}
